<template>
  <DataTable :columns="columnList" defaultColumnOrderDir="DESC" :defaultColumnOrderIndex="3" :url="dataURL" :filterOptions="filterOptions" :displayTools="true" :hasDateRangeFilter="true"  :displayExportTools="true" exportTitle="Over Payments">
    <template v-slot:title>
      <slot name="title" />
    </template>
    <template v-slot:tools>
      <slot name="tools" />
    </template>
    <template v-slot:row="row">
      <tr :key="row.data.id">
        <td class="table-data-nav-link">
          <LinkOverPayment :id="row.data.id" :name="row.data.sequenceNumber" :newTab="false" />
        </td>
        <td>
          <LabelBadge :labelClass="`label-payment-status-${row.data.status}`">{{row.data.status | formatLookupName(OverpaymentStatusTypeLookup)}}</LabelBadge>
        </td>
        <td>
          <LinkContact :id="row.data.contactId" :name="row.data.contactName" />
        </td>
        <td>{{row.data.dateCreated | formatDateTime}}</td>
        <td>
          {{row.data.amount | formatCurrency}}
        </td>
        <td>
          {{row.data.totalReservedAmount | formatCurrency}}
        </td>
        <td>
          {{row.data.remainingCredit | formatCurrency}}
        </td>
      </tr>
    </template>
    <template v-slot:summary="summary">
      <tr key="summary">
        <td>Totals</td>
        <td colspan="3"> </td>
        <td>{{summary.data.totalAmount | formatCurrency}}</td>
        <td>{{summary.data.totalReservedAmount | formatCurrency}}</td>
        <td>{{summary.data.totalRemainingCredit | formatCurrency}}</td>
      </tr>
    </template>
  </DataTable>
</template>

<script>
import Utils from '@/utils/utils'

import { OverpaymentStatusTypes, OverpaymentStatusTypeLookup } from '@/store/types'

export default {
  name: 'OverPaymentDataTable',
  props: {
    openNewTab: {
      type: Boolean,
      default: false
    },
    filterContactId: Number,
    filterType: String
  },
  created() {
    this.OverpaymentStatusTypeLookup = OverpaymentStatusTypeLookup
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    dataURL() {
      var params = {
        filter: {}
      }
      if(this.filterContactId)
        params.filter.contactId = this.filterContactId

      return '/accounts/overpayments?' + $.param(params)
    },
  },
  data() {
    return {
      filterOptions: [
        {
          field: 'status',
          name: 'Status',
          options: [
            { name: Utils.getLookupName(OverpaymentStatusTypeLookup, OverpaymentStatusTypes.pendingInvoice), value: OverpaymentStatusTypes.pendingInvoice, class: 'label-payment-status-pendingInvoice' },
            { name: Utils.getLookupName(OverpaymentStatusTypeLookup, OverpaymentStatusTypes.unallocated), value: OverpaymentStatusTypes.unallocated, class: 'label-payment-status-unallocated' },
            { name: Utils.getLookupName(OverpaymentStatusTypeLookup, OverpaymentStatusTypes.allocated), value: OverpaymentStatusTypes.allocated, class: 'label-payment-status-allocated' },
            { name: Utils.getLookupName(OverpaymentStatusTypeLookup, OverpaymentStatusTypes.cancelled), value: OverpaymentStatusTypes.cancelled, class: 'label-payment-status-cancelled' },
          ]
        }
      ],
      columnList: [
        { title: "Overpayment", data: "sequenceNumber" },
        { title: "Status", data: "status" },
        { title: "Contact", data: "contact.name" },
        { title: "Overpayment Date", data: "dateCreated", dateFilter: true, type: 'datetime' },
        { title: "Amount", data: "amount", type: 'currency', totalField: 'totalAmount' },
        { title: "Reserved Amount", data: "totalReservedAmount", type: 'currency', totalField: 'totalReservedAmount' },
        { title: "Remaining Credit", data: "remainingCredit", type: 'currency', totalField: 'totalRemainingCredit' },
      ]
    }
  },
  methods: {
  }
};
</script>
